import * as React from 'react';
import { Box } from "@mui/system"
import { Button, Slide, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2"
import { send_authorized_request } from '../../Constants/cognito'
import { AXIOS_API_INSTANCE } from '../../Constants';
import dayjs from "dayjs"
import { useSnackbar } from 'notistack';
import { LoadingBackdropIndeterminate } from '../LoadingBackdrop';
import ServiceNote from './ServiceNote';

export default function ServiceOrderNotes({ setServiceOrder, serviceOrder }) {
    const { enqueueSnackbar } = useSnackbar()
    const [newServiceNote, setNewServiceNote] = React.useState("")
    const [savingNote, setSavingNote] = React.useState(false)
    const newNoteParent = React.useRef(null);

    const addServiceNote = () => {
        setSavingNote(true)
        const serviceOrderNote = {
            text: newServiceNote
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(
                `serviceorders/${serviceOrder.id}/add_note`,
                serviceOrderNote
            ).then((serviceOrder) => {
                setSavingNote(false)
                enqueueSnackbar('Successfully created service order note', { variant: 'success' })
                setServiceOrder(serviceOrder.data.data)
                setNewServiceNote("")
            }).catch((error) => {
                setSavingNote(false)
                enqueueSnackbar(`Failed to create service order note <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    const notes = (serviceOrder?.service_order_notes || []).concat((serviceOrder?.service_order_work_history || []).map((x) => {
        const return_list = []
        if (x.diagnostic_note) {
            return_list.push({
                id: `diagnostic-${x.id}`,
                date_created: x.end_time,
                user_id: x.user_id,
                text: x.diagnostic_note,
                type: "diagnostic"
            })
        }
        if (x.overhead_note) {
            return_list.push({
                id: `overhead-${x.id}`,
                date_created: x.end_time,
                user_id: x.user_id,
                text: x.overhead_note,
                type: "overhead"
            })
        }
        x.service_order_work_history_entries.forEach((entry) => {
            const service_order_service_name = serviceOrder.service_order_services.find((service) => service.id === entry.service_order_service_id)?.name ?? 'Unknown Service'
            if (entry.note) {
                return_list.push({
                    id: `service-${x.id}-${entry.id}`,
                    date_created: x.end_time,
                    user_id: x.user_id,
                    text: entry.note,
                    type: "work_history",
                    service_name: service_order_service_name,
                })
            }
        })
        return return_list
    }).flat())

    return (
        (<Box>
            <LoadingBackdropIndeterminate
                open={savingNote}
                text="Saving Note"
            />
            <h3>Service Order Notes (Internal only)</h3>
            <Box>
                <TextField
                    margin="dense"
                    id="servicenote"
                    label="Service Order Note"
                    type="text"
                    fullWidth
                    variant="filled"
                    multiline
                    minRows={2}
                    value={newServiceNote}
                    onChange={(event) => setNewServiceNote(event.target.value)}
                    sx={{ mt: 0 }}
                    slotProps={{
                        input: { maxLength: 2055 }
                    }}
                />
                <Grid container spacing={1} justifyContent={'flex-end'} ref={newNoteParent} sx={{ overflow: 'hidden', height: Boolean(newServiceNote) ? '45px' : '10px', transition: "height 0.225s cubic-bezier(0, 0, 0.2, 1)" }}>
                    <Grid size="grow">
                        <span></span>
                    </Grid>
                    <Grid size="auto">
                        <Slide in={Boolean(newServiceNote)} container={newNoteParent.current}>
                            <Button variant="contained" onClick={addServiceNote}>
                                Add Note
                            </Button>
                        </Slide>
                    </Grid>
                </Grid>
                <Box sx={{ pb: 1 }}>
                    {
                        (notes).sort((a, b) => dayjs.utc(b.date_created).unix() - dayjs.utc(a.date_created).unix()).map((item) => {
                            return (<ServiceNote
                                key={item.id}
                                serviceNote={item}
                            />
                            )
                        })
                    }
                </Box>
            </Box>
        </Box>)
    );
}